import { render } from "./editMenu.vue?vue&type=template&id=8159362c"
import script from "./editMenu.vue?vue&type=script&lang=js"
export * from "./editMenu.vue?vue&type=script&lang=js"

import exportComponent from "D:\\programmazione\\pronails\\MemsionPrivato\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__